export const VALIDATION_TYPES = [
    'none',
    'formate'
]

export const VALIDATION_FILED_NAME = 'validations'
